export default {
	en: "en-US",
	pt: "pt-BR",
	es: "es-UY",
};
